/**
 * Build-time feature flags.
 *
 * INTERVIEWS_ENABLED gates every interview surface in the Console — the Interview stage
 * tab, the bulk "Interview" action, "Start AI calls", the Schedule-interviews panel and
 * the I / ⌘K shortcuts — so the pipeline can run screening-only.
 *
 * This is UX, not enforcement: the interview endpoints stay live and a stale tab or a
 * direct API call still reaches them. It exists to stop an accidental click placing a
 * real phone call to a candidate, not to secure the endpoint.
 *
 * Pair it with the server's GENERATE_INTERVIEW_QUESTIONS=false, which stops paying for
 * interview questions nothing reads. Set REACT_APP_INTERVIEWS_ENABLED=false to hide;
 * unset (or any other value) leaves interviews on, so this is opt-in to hiding.
 */
export const INTERVIEWS_ENABLED = process.env.REACT_APP_INTERVIEWS_ENABLED !== "false";
